import { render, staticRenderFns } from "./dialogWrapper.vue?vue&type=template&id=f5ec7b78&"
import script from "./dialogWrapper.vue?vue&type=script&lang=ts&"
export * from "./dialogWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports